

export const goToStep2 = (thisRefs, currentIndex ) => {
  thisRefs.formWizard.changeTab(currentIndex - 1, 2);
}
export const goToStep3 = (thisRefs, currentIndex ) => {
  thisRefs.formWizard.changeTab(currentIndex - 1, 3);
}
export const goToStep4 = (thisRefs, currentIndex ) => {
  thisRefs.formWizard.changeTab(currentIndex - 1, 4);
}
export const goToStep5 = (thisRefs, currentIndex ) => {
  thisRefs.formWizard.changeTab(currentIndex - 1, 5);
}
export const goToStep1 = (thisRefs, currentIndex ) => {
  thisRefs.formWizard.changeTab(currentIndex - 1, 1);
}

export const goToStep0 = (thisRefs, currentIndex ) => {
  thisRefs.formWizard.changeTab(currentIndex - 1, 0);
}